import React from 'react';
import './DailyPlan.css';

function DailyPlan({ day, breakfast, lunch, dinner, snack, workout }) {
  return (
    <div className="daily-plan">
      <div className="day-header">
        <h2>Day {day}</h2>
        <span className="day-calories">
          {breakfast.calories + lunch.calories + dinner.calories + (snack?.calories || 0)} kcal
        </span>
      </div>

      <div className="meals-section">
        <div className="meal">
          <div className="meal-header">
            <span className="meal-time">🍳 Breakfast</span>
            <span className="meal-macros">{breakfast.calories} kcal</span>
          </div>
          <p className="meal-description">{breakfast.meal}</p>
          <div className="meal-nutrition">
            <span>P: {breakfast.protein}g</span>
            <span>C: {breakfast.carbs}g</span>
            <span>F: {breakfast.fat}g</span>
          </div>
        </div>

        <div className="meal">
          <div className="meal-header">
            <span className="meal-time">🥗 Lunch</span>
            <span className="meal-macros">{lunch.calories} kcal</span>
          </div>
          <p className="meal-description">{lunch.meal}</p>
          <div className="meal-nutrition">
            <span>P: {lunch.protein}g</span>
            <span>C: {lunch.carbs}g</span>
            <span>F: {lunch.fat}g</span>
          </div>
        </div>

        <div className="meal">
          <div className="meal-header">
            <span className="meal-time">🍽️ Dinner</span>
            <span className="meal-macros">{dinner.calories} kcal</span>
          </div>
          <p className="meal-description">{dinner.meal}</p>
          <div className="meal-nutrition">
            <span>P: {dinner.protein}g</span>
            <span>C: {dinner.carbs}g</span>
            <span>F: {dinner.fat}g</span>
          </div>
        </div>

        {snack && (
          <div className="meal">
            <div className="meal-header">
              <span className="meal-time">🥤 Snack</span>
              <span className="meal-macros">{snack.calories} kcal</span>
            </div>
            <p className="meal-description">{snack.meal}</p>
            <div className="meal-nutrition">
              <span>P: {snack.protein}g</span>
              <span>C: {snack.carbs}g</span>
              <span>F: {snack.fat}g</span>
            </div>
          </div>
        )}
      </div>

      {workout && (
        <div className="workout-section">
          <h3>💪 {workout.focus}</h3>
          <p className="workout-muscles">{workout.muscles}</p>
          <p className="workout-duration">{workout.duration}</p>
          <ul className="exercise-list">
            {workout.exercises.map((exercise, idx) => (
              <li key={idx}>
                <span className="exercise-name">{exercise.name}</span>
                <span className="exercise-details">
                  {exercise.sets} sets × {exercise.reps} | Rest: {exercise.rest}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default DailyPlan;
